export const CLOSE_TIME_OUT_MS = 150;
export const TEST = {
    SUBMIT_BUTTON_NAME: 'submit',
    MESSAGE_ERROR_REQUIRED: 'validation-required',
    PROFILE_MODEL: 'userProfile.test',
    NAME: 'testSelectList',
    PLACEHOLDER: 'testPlaceholder',
    TOOLTIP: 'testTooltip',
    OPTIONS: [
        {
            label: 'test1',
            value: 1,
        },
        {
            label: 'test2',
            value: 2,
        },
        {
            label: 'test3',
            value: 3,
        },
    ],
};
